import { DossierDetailsView } from "@/app/pages/dossier/dossier-details-panel";
import { useGetTvvBesteldeRoutes } from "@/entities/tvv";
import { useBestelTVVRoutes } from "@/features/tvv/components/regievoerder/bestel-routes-context.ts";
import { BestelRoutesProvider } from "@/features/tvv/components/regievoerder/bestel-routes-provider.tsx";
import { TvvDetailsSkeleton } from "@/features/tvv/components/shared";
import { useEffect, useRef } from "react";
import { BestellingView } from "./bestelling-versturen";
import { BesteloverzichtView } from "./besteloverzicht";
import { RoutesZoekenView } from "./route-zoeken/route-zoeken-view";
import { RoutesSelecterenView } from "./routes-selecteren";

type TvvDetailsRegievoerderProps = {
    dossierId: string;
};

export function TvvDetailsRegievoerder({ dossierId }: Readonly<TvvDetailsRegievoerderProps>) {
    const query = useGetTvvBesteldeRoutes(dossierId);

    return (
        <DossierDetailsView section="Tvv" query={query} skeleton={<TvvDetailsSkeleton />} errorTitle="Fout bij het laden van TVV">
            {(besteldeRoutes) => (
                <BestelRoutesProvider dossierId={dossierId} besteldeRoutes={besteldeRoutes}>
                    <TvvRegievoerderContent dossierId={dossierId} />
                </BestelRoutesProvider>
            )}
        </DossierDetailsView>
    );
}

type TvvRegievoerderContentProps = {
    dossierId: string;
};

function TvvRegievoerderContent({ dossierId }: Readonly<TvvRegievoerderContentProps>) {
    const { besteldeRoutes, mode, setMode } = useBestelTVVRoutes();
    const prevRoutesCount = useRef(besteldeRoutes.length);

    // Auto-switch to overzicht when new orders are created
    useEffect(() => {
        const currentCount = besteldeRoutes.length;
        if (currentCount > prevRoutesCount.current && mode === "selecteren") {
            setMode("overzicht");
        }
        prevRoutesCount.current = currentCount;
    }, [besteldeRoutes.length, mode, setMode]);

    switch (mode) {
        case "zoeken":
            return <RoutesZoekenView dossierId={dossierId} />;
        case "selecteren":
            return <RoutesSelecterenView dossierId={dossierId} hasOrders={!!besteldeRoutes.length} />;
        case "bestellen":
            return <BestellingView dossierId={dossierId} />;
        default:
            return <BesteloverzichtView dossierId={dossierId} />;
    }
}
